import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import PublicForm from './PublicForm';

const path = window.location.pathname;
const root = ReactDOM.createRoot(document.getElementById('root'));

if (path.startsWith('/form/') || path.startsWith('/task/form/')) {
  root.render(<React.StrictMode><PublicForm /></React.StrictMode>);
} else {
  root.render(<React.StrictMode><App /></React.StrictMode>);
}
